'use client';

import { FiltersData } from '@/types/offerWall';
import { SetStateAction, useEffect, useState } from 'react';
import styles from './Checkbox.module.scss';

interface Props {
  label: string;
  currentLenders: null | string[];
  setFiltersData: React.Dispatch<SetStateAction<FiltersData>>;
}

const Checkbox = ({ label, currentLenders, setFiltersData }: Props) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (checked) {
      setFiltersData((prev) => ({
        ...prev,
        lenders: prev.lenders ? [...prev.lenders, label] : [label],
      }));
    } else {
      setFiltersData((prev) => ({
        ...prev,
        lenders: prev.lenders
          ? prev.lenders.filter((lender) => lender !== label)
          : null,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  useEffect(() => {
    if (!currentLenders) {
      setChecked(false);
    } else if (currentLenders.includes(label)) {
      setChecked(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLenders]);

  return (
    <div className={styles.wrapper}>
      <input
        id={label}
        name={label}
        type="checkbox"
        className={styles.input}
        onChange={(e) => setChecked(e.target.checked)}
        checked={checked}
      />
      <label htmlFor={label} className={styles.label}>
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
